// The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.
let module = angular.module('switcher-studio', []);

module.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state('switcher-studio', {
      url: '/switcher-studio',
      template: '<div ui-view></div>',
      abstract: true,
    })
    .state('switcher-studio.events', {
      url: '',
      template: require('./events.html'),
      controller: require('./events.js').default,
      controllerAs: 'vm',
    });
});

export default module;



// WEBPACK FOOTER //
// ./app/pages/switcher-studio/_index.js